module.exports = __webpack_public_path__ + "img/mockup-ixxo.43e39ef2.png";